// olap-client/src/components/chat/MessageInput.jsx
import React, { useContext, useState, useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';

const MessageInput = observer(() => {
  const { chat } = useContext(Context);
  const [inputText, setInputText] = useState('');
  const typingTimeoutRef = useRef(null);

  // При начале редактирования - заполняем input текстом сообщения
  useEffect(() => {
    if (chat.editingMessage) {
      setInputText(chat.editingMessage.text);
    } else {
      setInputText('');
    }
  }, [chat.editingMessage]);

  const handleSend = () => {
    if (!inputText.trim()) return;
    chat.sendMessage(inputText);
    setInputText('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputText(value);
    
    if (value.trim() && !typingTimeoutRef.current) {
      chat.sendTyping();
    }
    
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    
    if (value.trim()) {
      typingTimeoutRef.current = setTimeout(() => {
        chat.sendStopTyping();
        typingTimeoutRef.current = null;
      }, 2000);
    } else {
      chat.sendStopTyping();
      typingTimeoutRef.current = null;
    }
  };

  return (
    <>
      {/* Блок ответа на сообщение */}
      {chat.replyingTo && (
        <div style={{
          padding: '8px 12px',
          background: '#f4f4f5',
          borderLeft: '3px solid #3390ec',
          margin: '0 10px',
          borderRadius: '4px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ flex: 1, overflow: 'hidden' }}>
            <div style={{ fontSize: '12px', color: '#3390ec', fontWeight: 'bold' }}>
              Ответ {chat.replyingTo.sender?.persons_info?.name || 'Пользователю'}
            </div>
            <div style={{ 
              fontSize: '13px', 
              color: '#707579', 
              marginTop: '2px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {chat.replyingTo.text?.substring(0, 50)}
            </div>
          </div>
          <button
            onClick={() => chat.cancelReply()}
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#999',
              padding: '0 5px'
            }}
          >
            ×
          </button>
        </div>
      )}

      {/* Поле ввода */}
      <div style={{
        padding: '10px',
        borderTop: '1px solid #e4e4e5',
        display: 'flex',
        gap: '8px',
        background: chat.editingMessage ? '#fff3cd' : 'white',
        alignItems: 'center',
        flexShrink: 0
      }}>
        {chat.editingMessage ? (
          <>
            <button
              onClick={() => chat.cancelEditing()}
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: 'pointer',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              title="Отменить"
            >
              ×
            </button>
            <input
              type="text"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  if (inputText.trim()) {
                    chat.editMessage(chat.editingMessage.id, inputText);
                    setInputText('');
                  }
                }
              }}
              placeholder="Редактирование сообщения..."
              autoFocus
              style={{
                flex: 1,
                padding: '10px 15px',
                borderRadius: '20px',
                border: '1px solid #ffc107',
                outline: 'none',
                fontSize: '14px'
              }}
            />
            <button
              onClick={() => {
                if (inputText.trim()) {
                  chat.editMessage(chat.editingMessage.id, inputText);
                  setInputText('');
                }
              }}
              disabled={!inputText.trim()}
              style={{
                background: inputText.trim() ? '#28a745' : '#ccc',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: inputText.trim() ? 'pointer' : 'not-allowed',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              title="Сохранить"
            >
              ✓
            </button>
          </>
        ) : (
          <>
            <input
              type="text"
              value={inputText}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              placeholder="Введите сообщение..."
              style={{
                flex: 1,
                padding: '10px 15px',
                borderRadius: '20px',
                border: '1px solid #e4e4e5',
                outline: 'none',
                fontSize: '14px'
              }}
            />
            <button
              onClick={() => {
                if (inputText.trim()) {
                  chat.sendMessage(inputText);
                  setInputText('');
                }
              }}
              disabled={!inputText.trim()}
              style={{
                background: inputText.trim() ? '#3390ec' : '#ccc',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                cursor: inputText.trim() ? 'pointer' : 'not-allowed',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ➤
            </button>
          </>
        )}
      </div>
    </>
  );
});

export default MessageInput;